<template>
  <div id="homelesson-container">
    <BottomBar />
    <keep-alive>
      <Landing v-if="state == 1" @state="state += $event" />
      <Package
        v-if="state == 2"
        :data="data"
        :packages="packages"
        @state="state += $event"
        @update="update($event)"
      />
      <Timeslot v-if="state == 3" :data="data" @state="state += $event" @update="update($event)" />
      <Date v-if="state == 4" :data="data" @state="state += $event" @update="update($event)" />
      <Push
        v-if="state == 5"
        :data="data"
        @destroy="$destroy()"
        @state="state += $event"
        @update="update($event)"
      />
    </keep-alive>
    <Popup v-if="isShowPopup" :msg="popupMsg" @close="isShowPopup = false" />
    <div
      v-if="state > 1 && state < 5"
      id="price-table"
      class="price animated slideInUp"
      @click="isShowPopup = true"
    >
      <div class="top">
        <h1 class="left">
          <i class="anyteachicon anyteach-dollar-sign" />
          <span v-if="price">课程单价</span>
          <span v-else>定制您的课程以查看价格</span>
        </h1>
        <h1 v-if="price" id="price" class="right">{{ price }} 元</h1>
      </div>
      <div class="bottom">
        <p>邀请首单好友发起人立减 10%，点按了解更多</p>
      </div>
    </div>
  </div>
</template>
<script>
import Landing from "./Landing.vue"
import Package from "./Package.vue"
import Timeslot from "./Timeslot.vue"
import Date from "./Date.vue"
import Push from "./Push.vue"
import Popup from "../../public/Popup.vue"
import BottomBar from "../../public/footer.vue"
export default {
  name: "HomelessonContainer",
  components: {
    Landing,
    Package,
    Timeslot,
    Date,
    Push,
    Popup,
    BottomBar,
  },
  data() {
    return {
      state: 1,
      isShowPopup: false,
      popupMsg: "",
      data: {},
      price: "",
      prices: [],
      package: "",
      packages: [],
    }
  },
  watch: {
    price: function (val) {
      this.data.price = val
    },
    package: function (val) {
      this.data.package = val
    },
  },
  created() {
    this.getPackages()
    this.initWeChat()
    this.popupMsg = {
      title: "邀请首单好友",
      content: [
        {
          content:
            "“首单好友”指的是第一次在 AnyTeach 约课平台上支付课程的用户。邀请首单好友加入课程，不论您是发起人或参与人，可以立即获得奖励。",
        },
        {
          title: "发起人",
          content: "邀请首单用户，发起人学费立减 10%。",
        },
        {
          title: "参与人",
          content: "邀请首单好友，立即获得一张 100 元同城拼课学习券。",
        },
      ],
    }
  },
  methods: {
    update(event) {
      for (const key in event) {
        this.data[key] = event[key]
      }
      if (this.data.pax && this.data.sessions && this.data.teacher_type && this.data.duration) {
        this.package = this.prices.filter(
          item =>
            item.pax == this.data.pax.index &&
            item.regular == this.data.sessions.regular &&
            item.extra == this.data.sessions.extra &&
            item.teacher_type == this.data.teacher_type,
        )[0]
        this.price = this.package.price * this.data.duration
      }
      this.data = JSON.parse(JSON.stringify(this.data))
    },
    getPackages() {
      this.$axios({
        url: window.PHP_ROOT + "/index/collage/package",
        method: "POST"
      }).then(({ data }) => {
        if (data.code == 1000) {
          this.prices = data.msg
          this.prices.forEach(item => {
            if (this.packages.every(e => e.regular != item.regular && e.extra != item.extra)) {
              this.packages.push(item)
            }
          })
        }
      }).catch(err => this.$toast("获取价格失败，请刷新重试"))
    },
    initWeChat() {
      wx.ready(() => {
        bus.wxShareConfig({
          type: "custom",
          title: "发起 AnyTeach 同城拼课",
          desc: "1 至 8 人、时间地点由你决定，邀请首单用户立减 10%",
          link: "http://wx.anyteach.cn/#/homeclass/post",
          imgUrl: window.logo2019,
        })
      })
    },
  },
}
</script>
<style scoped lang="scss">
// @import "../../../../static/css/public.scss";

#homelesson-container {
  min-height: 100vh;
  background: white;
  padding-bottom: $bottom-bar;
  padding-bottom: $iphone-x-bottom-bar;
  // @include avenir();

  #price-table {
    animation-delay: 0s !important;
    animation-duration: 0.5s !important;
  }

  .price {
    position: fixed;
    bottom: $bottom-bar;
    bottom: $iphone-x-bottom-bar;
    width: 100%;
    background: #f5f5f5;
    padding: 10px 5% 8px 5%;
    transition: 0.1s;
    border-top: 1px solid #eee;
    border-bottom: 1px solid #eee;
    z-index: 2;
    &:active {
      background: #e8e7e7;
    }
    .top {
      display: flex;
      justify-content: space-between;
      margin-bottom: 3px;
    }
    .bottom {
    }

    h1 {
      font-size: 15px;
      font-weight: 500;
      color: $black;
      margin: 0;
      padding: 0;
    }
    .right {
      @include avenir-demi();
    }

    p {
      font-size: 13px;
      font-weight: 400;
      opacity: 0.6;
      margin: 0;
      padding: 0;
    }

    i {
      margin-right: 5px;
    }
  }

  @media only screen and (device-width: 375px) and (device-height: 812px) and (-webkit-device-pixel-ratio: 3) {
    #price-table {
      /*height: 94px;*/
    }
  }
}
</style>
